import { useEffect, useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import "./ScrollText.css";

const defaultTexts = [
    "Learn from Experts",
    "Start with Free Classes",
    "Pay in Easy Installments",
];

const ScrollText = ({
    texts = defaultTexts,
    interval = 2500,
    className = "",
    label = "Why Learn With Us?",
}) => {
    const [currentText, setCurrentText] = useState(0);
    const [isAnimating, setIsAnimating] = useState(true);

    useEffect(() => {
        if (!texts || texts.length <= 1) {
            return;
        }

        let changeTimer;
        let animationTimer;

        const changeText = () => {
            setIsAnimating(false);

            animationTimer = setTimeout(() => {
                setCurrentText((prev) => (prev + 1) % texts.length);
                setIsAnimating(true);
            }, 300);
        };

        changeTimer = setInterval(changeText, interval);

        return () => {
            clearInterval(changeTimer);
            clearTimeout(animationTimer);
        };
    }, [texts, interval]);

    if (!texts || texts.length === 0) {
        return null;
    }

    return (
        <section
            className={`rollings-wrapper ${className}`}
            aria-label={label}
        >
            <div className="rollings-container">

                {/* Label */}
                <div className="rollings-label">
                    <span className="rollings-label-dot"></span>
                    <span>{label}</span>
                </div>

                {/* Content */}
                <div className="rollings-content">

                    <CheckCircleIcon className="rollings-icon" />

                    <div
                        className={`rollings-text ${
                            isAnimating ? "rollings-active" : ""
                        }`}
                        aria-live="polite"
                    >
                        {texts[currentText]}
                    </div>

                </div>

                {/* Progress Indicators */}
                {texts.length > 1 && (
                    <div className="rollings-indicators">
                        {texts.map((_, index) => (
                            <span
                                key={index}
                                className={`rollings-indicator ${
                                    index === currentText
                                        ? "rollings-indicator-active"
                                        : ""
                                }`}
                            />
                        ))}
                    </div>
                )}

            </div>
        </section>
    );
};

export default ScrollText;